import $ajax from "../request"
const BaseUrl = location.origin;
const getDetail = () => {
    return new Promise(resolve => {
        $ajax.get(BaseUrl + '/app/wx/home/getLitemallHomeMemberShow', {}).then(res => {
            const { data } = res;
            resolve(data);
        })
    })
}

export {
    getDetail
}